/* unplugin-vue-components disabled */import { render } from "./InviteRecord.vue?vue&type=template&id=bfedaa5c&scoped=true"
import script from "./InviteRecord.vue?vue&type=script&lang=js"
export * from "./InviteRecord.vue?vue&type=script&lang=js"

import "./InviteRecord.vue?vue&type=style&index=0&id=bfedaa5c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfedaa5c"]])

export default __exports__